export default __webpack_public_path__ + "static/media/simba.ce7aa6db.jpg";